import { useMutation, useQueryClient } from '@tanstack/react-query';

import { timeoutDelay } from '@constants/timeoutDelay';

import { equipmentsLogListKey } from '@pages/ManageEquipment/services/useEquipmentsLogListInfiniteQuery';
import { allEquipmentsListKey } from '@pages/ManageTemplate/services/useAllEquipmentsListQuery';
import { locationsAssetsKey } from '@pages/Sensors/services/useLocationsAssetsQuery';

import { apiClient } from '@services/apiClient';

import { equipmentsViewKey } from './useEquipmentsViewQuery';

interface IData {
  asset_code: string;
  equipment_id?: number;
  is_replace_name?: number;
  check_code?: number;
}

const equipmentEditAssetCodeFn = (data: IData) =>
  apiClient.post(`${APP_API_URL}equipments/edit-asset-code`, data);

export const useEquipmentEditAssetCodeMutation = ({ locationId }: { locationId?: number | string }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: equipmentEditAssetCodeFn,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: allEquipmentsListKey({ locationId: locationId?.toString() }),
        exact: true,
      });
      queryClient.invalidateQueries({ queryKey: [locationsAssetsKey({ locationId })[0]], exact: true });
      queryClient.invalidateQueries({ queryKey: [equipmentsViewKey()[0]] });
      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: [equipmentsLogListKey()[0]] });
      }, timeoutDelay);
    },
  });
};
